// Select all input fields within form areas
document.querySelectorAll('[form-area] .input').forEach(input => {
    console.log(":)");
    input.addEventListener('keydown', function (event) {
        // Check if the pressed key is 'Enter'
        if (event.key === 'Enter') {
            // Find the closest form area
            const formArea = this.closest('[form-area]');

            // Prefer a button with the class 'cta', but fall back to any button if none is found
            let ctaButton = formArea.querySelector('.cta') || formArea.querySelector('button');

            // Trigger a click on the button if it exists
            if (ctaButton) {
                ctaButton.click();
            }
        }
    });
});
